import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { WidgetsServiceService } from 'src/app/modules/home/widgets-collection/widgets-service.service';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';
import * as moment from "moment-timezone";
import { TimePeriod } from 'ngx-daterangepicker-material/daterangepicker.component';

@Component({
  selector: 'app-telematics-histroy',
  templateUrl: './telematics-histroy.component.html',
  styleUrls: ['./telematics-histroy.component.css']
})
export class TelematicsHistroyComponent implements OnInit, OnDestroy {
  @Input() entityData: any;
  transformedAttributeData: any = [];
  pageSizeLimit: any = [];
  teleHistoryConfig: any = {};
  currentStatHistoryPage: number = 1;
  totalPages: any = [];
  isloader: boolean = false;
  pageSize = new FormControl();
  datePicker = new FormControl(new Date());
  apiHitTime: Date;
  tableActionList: any = { pagination: false, flag: true };
  pager:any ={};

  private _activeEntityDetailsSubscription: Subscription;
  private _subscription: Subscription;
  private _updateEntityDataSubscription: Subscription;

  public datepickerForm: FormGroup;
  private _selectedDates = {
    from: null,
    to: null,
  };
  private _initializeForm(type: string = 'default') {
    this.datepickerForm = this._fb.group({
      thisdate: null
    });
  }
  
  constructor(
    public _service: ServicecallService,
    private _entityService: EntitiesServiceService,
    private _datePipe: DatePipe,
    private _widgetService: WidgetsServiceService,
    private _dataSer: DataService,
    private _fb: FormBuilder
  ) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this.activeEntityDetails(1);
      }
    });
  }

  ngOnInit(): void {
    this.pageSizeLimit = this._service.getConfiguration('pageLimits') ? this._service.getConfiguration('pageLimits')?.pageLimits : [];
    this.teleHistoryConfig = this._service.getConfigurationBasedOnCategory(this.entityData) ?
      this._service.getConfigurationBasedOnCategory(this.entityData) : [];
    if (this._service.getConfiguration('tenantGenericConfig')?.tenant !== 'TRL') {
      this.tableActionList = { pagination: false };
    }
    this.pageSize.setValue(this.pageSizeLimit[0]);
    //Initializing Date-time range picker
    this._initializeForm();
    const { startDate, endDate } = this._service.getConfiguration('tenantGenericConfig')?.defaultTimeRange
      ? this._service.calculateDateRange(this._service.getConfiguration('tenantGenericConfig')?.defaultTimeRange)
      : { startDate: new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 0, 0, 0, 999), 
        endDate: new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 23, 59, 59, 999) };

    this.datepickerForm.setValue({
      thisdate: { startDate, endDate }
    });
    if (this._service.getConfiguration('tenantGenericConfig').defaultTimeRange) {
      this._selectedDates = { from: startDate, to: endDate };
    }
    //Initializing Date-time range picker
    this.activeEntityDetails(1);
  }

  activeEntityDetails(pageNo?: number) {
    this.apiHitTime = new Date();
    this.currentStatHistoryPage = pageNo ? pageNo : this.currentStatHistoryPage;
    const startDate = new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 0, 0, 0, 999);
    const endDate = new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 23, 59, 59, 999);
    this.isloader = true;
    const requestData = {
      siteId: this._service.getSiteId(),
      from: this._datePipe.transform(this._selectedDates.from ?? startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this._selectedDates.to ?? endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityData?._id,
      count: this.pageSize?.value
    };
    this._activeEntityDetailsSubscription = this._widgetService.activeEntityDetails(requestData, this.currentStatHistoryPage).subscribe({
      next: (result: any) => {
        if (result['status']) {
          if (result['response']['data']?.length) {
            let transformedCurrentData = [];
            [...result['response']['data']].forEach((item: any) => {
              const transformedCurrentObj = this._service.flattenObject(item, 'vitals');
              transformedCurrentData.push(transformedCurrentObj);
            });
            this.transformedAttributeData = transformedCurrentData;
            this.transformedAttributeData.map((elem: any) => {
              elem['time'] = this._service.getLastSeenFormat(elem.sourceTimestamp);
              elem['zoneName'] = elem?.zoneName;
              if (!elem['attrValid']) {
                elem['attrValid'] = false;
              }
              elem.attributes?.forEach((item: any) => {
                if (item?.attributeName === 'RUL_BRAKE_PAD' || item?.attributeName === 'RUL_CLUTCH_PAD') {
                  elem[item.attributeName + '_Time'] = item.processedTime;
                }
              });
            });
            transformedCurrentData = [];
            this.clearUnwantedValues();
            if (result['response']['pageInfo']) {
                this.pager = { ...result['response']['pageInfo'] };
            }
          } else {
            this.transformedAttributeData = [];
            this.totalPages = [];
            if (result?.response?.message)
              this._service.toasterService({ type: 'error', msg: result?.response?.message });
          }
        }
        else {
          this.transformedAttributeData = [];
          if (result?.response?.message)
            this._service.toasterService({ type: 'error', msg: result?.response?.message });
        }
        this.isloader = false;
      }, error: (error) => {
        if (error) {
          this.transformedAttributeData = [];
          this.isloader = false;
        }
      }
    });
  }

  clearUnwantedValues() {
    if (this.teleHistoryConfig?.attributesTableHeader) {
      const tableHeaderKeys = Object.keys(this.teleHistoryConfig?.attributesTableHeader);
      tableHeaderKeys.push('sourceTimestamp', 'RUL_BRAKE_PAD_Time', 'RUL_CLUTCH_PAD_Time', 'attrValid', '_id');
      if (tableHeaderKeys?.length) {
        this.transformedAttributeData?.forEach((item: any) => {
          const keysList = Object.keys(item);
          if (keysList?.length) {
            keysList?.forEach((key: any) => {
              if (!tableHeaderKeys?.includes(key?.toString())) {
                delete item[key];
              }
            });
          }
        });
      }
    }
  }

  tableAction(event: any) {
    if (event?.type === 'flag') {
      this._setFlagDetails(event);
    }else if(event?.type === 'export'){
      this.activeEntityExport(event);
    }
  }

  activeEntityExport(event:any) {
    const startDate = new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 0, 0, 0, 999);
    const endDate = new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 23, 59, 59, 999);
    const reqParam = {
      from: this._datePipe.transform(this._selectedDates.from ?? startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this._selectedDates.to ?? endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityData?._id,
      exportFormat: event?.item,
      timezone: sessionStorage.getItem('selectedTimeZone')?sessionStorage.getItem('selectedTimeZone'):moment.tz.guess(),
      exportFilename: 'Telematics History',
      fields: this._service.getConfigurationBasedOnCategory(this.entityData, 'export') ?
      this._service.getConfigurationBasedOnCategory(this.entityData, 'export')?.export?.telematicsHistory : []
    }
      this._service.commonExport(event?.item,reqParam,'activeEntityExport','Export_Telematics_History_', null, this.entityData?.uniqueId, null, 'telematicsHistory', this._selectedDates.from ?? startDate, this._selectedDates.to ?? endDate)
  }

  saveTime(data?: any) {
    if (data) {
      let dateRange: TimePeriod = data;
      const offsetTime = new Date().getTimezoneOffset() * 60 * 1000;
      this._selectedDates.from = this._getTimestampInMillisecond(dateRange?.startDate?.toDate()) + (offsetTime)
      this._selectedDates.to = this._getTimestampInMillisecond(dateRange?.endDate?.toDate()) + (offsetTime)
      // this.datepickerForm.setValue({
      //   thisdate: {startDate: this._selectedDates.from, endDate: this._selectedDates.to }
      // });
    } 
    this.activeEntityDetails(1);
  }

  private _getTimestampInMillisecond(date: Date): number {
    return date ? new Date(date)?.getTime() : 0;
  }

 ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._activeEntityDetailsSubscription?.unsubscribe();  
    this._updateEntityDataSubscription?.unsubscribe();      
  }
  
  private _setFlagDetails(event: any) {
    const reqData = {
      data: {
        attrValid: !event?.item?.attrValid
      },
      _id: event?.item?._id
    };
    this._updateEntityDataSubscription = this._entityService.updateEntityData(reqData).subscribe((result: any) => {
      if (result['status']) {
        this._service.toasterService({ type: 'success', msg: result?.response?.message });
        this.activeEntityDetails(this.currentStatHistoryPage);
      } else {
        this._service.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

}
